import { render, staticRenderFns } from "./riepilogo.vue?vue&type=template&id=6930ab92&"
import script from "./riepilogo.vue?vue&type=script&lang=js&"
export * from "./riepilogo.vue?vue&type=script&lang=js&"
import style0 from "./riepilogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports